"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const smartPricingApiFactory = (http, prefix = '/pricing_sync') => ({
    syncPrices(propertyId) {
        return http.post(`${prefix}/sync/${propertyId}`);
    },
    checkRegionSupport(propertyId, latitude, longitude) {
        console.log('Checking region support via API');
        return http.post(`${prefix}/verify/${propertyId}`, {
            latitude,
            longitude,
        });
    },
});
exports.default = smartPricingApiFactory;
//# sourceMappingURL=smartPricing.js.map